import { ScheduledMaintenancesLoader } from 'components/statusPage/scheduledMaintenancesLoader';
import { ServiceStatusLoader } from 'components/statusPage/serviceStatusLoader';
import { Incident } from 'components/statusPage/types';
import { UnresolvedIncidentsLoader } from 'components/statusPage/unresolvedIncidentsLoader';

export class ActiveIncidents {
  private serviceStatus: Incident['status'] = 'operational';

  private unresolvedIncidents: Incident[] = [];

  private activeMaintenances: Incident[] = [];

  async load(): Promise<Incident[]> {
    try {
      await Promise.allSettled([
        this.requestServiceStatus(),
        this.requestUnresolvedIncidents(),
        this.requestScheduledMaintenances()
      ]);
      return this.getActiveIncidents();
    } catch (error) {
      return [];
    }
  }

  async requestServiceStatus(): Promise<void> {
    this.serviceStatus = (await new ServiceStatusLoader(
      `${CONFIG.statusPageUrl}/api/v2/components.json`
    ).load()) as Incident['status'];
  }

  async requestUnresolvedIncidents(): Promise<void> {
    this.unresolvedIncidents = (await new UnresolvedIncidentsLoader(
      `${CONFIG.statusPageUrl}/api/v2/incidents.json`
    ).load()) as Incident[];
  }

  async requestScheduledMaintenances(): Promise<void> {
    this.activeMaintenances = (await new ScheduledMaintenancesLoader(
      `${CONFIG.statusPageUrl}/api/v2/scheduled-maintenances.json`
    ).load()) as Incident[];
  }

  getActiveIncidents(): Incident[] {
    if (this.serviceStatus === 'operational') {
      return [];
    }

    return this.activeMaintenances.concat(this.unresolvedIncidents);
  }
}
